import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/react-hooks";
import { BrowserRouter } from "react-router-dom";

import NavBar from "shared/components/NavBar";
import addToGlobalStore from "shared/redux/addToGlobalStore";
import getApolloClient from "shared/util/getApolloClient";
import OnDOMReady from "shared/util/OnDOMReady";
import isSpa from "shared/util/isSpa";
import { isDesktop } from "shared/util/EnvironmentHelpers";

import { reducer } from "ducks/navbar";

const NAV_BAR_ROOT_ELEMENT_ID = "navigation";

// eslint-disable-next-line import/no-mutable-exports
let store;

OnDOMReady(() => {
	if (isSpa()) {
		return;
	}

	store = addToGlobalStore({
		navbar: reducer,
	});

	const root = document.getElementById(NAV_BAR_ROOT_ELEMENT_ID);

	if (!root) return;

	if (isDesktop) {
		ReactDOM.render(
			<ApolloProvider client={getApolloClient()}>
				<Provider store={store}>
					<BrowserRouter>
						<NavBar />
					</BrowserRouter>
				</Provider>
			</ApolloProvider>,
			root,
		);
	}
});

export {
	store,
};



// WEBPACK FOOTER //
// ./src/features/navbar/index.js